import type { ComboboxItem } from "@mantine/core";

export type RecursiveSelectItem = ComboboxItem & {
  parts?: RecursiveSelectItem[];
};

export const collectPartValues = <K extends RecursiveSelectItem>(
  item: K,
  visited = new Set<string>(),
): string[] => {
  if (visited.has(item.value) || !item.parts?.length) return [];

  const nextVisited = new Set(visited);
  nextVisited.add(item.value);

  const partValues: string[] = [];
  item.parts.forEach(part => {
    partValues.push(part.value);
    partValues.push(...collectPartValues(part as K, nextVisited));
  });

  return partValues;
};

export const getCollectionCheckboxState = (
  item: RecursiveSelectItem,
  selectedValues: string[],
) => {
  const partValues = collectPartValues(item);
  if (!partValues.length) return null;

  const allSelected = partValues.every(value => selectedValues.includes(value));
  const someSelected = partValues.some(value => selectedValues.includes(value));

  return {
    checked: allSelected,
    indeterminate: someSelected && !allSelected,
  };
};
